import { homeConstants } from '../constants/home.constants';
import { getFirebase } from 'react-redux-firebase';
import { alertActions } from './alert.actions';
import { EventTypes } from 'redux-segment';

export const homeActions = {
  openEditBoard,
  closeEditBoard,
  selectProject,
  openTaskDialog,
  taskDialogSelect,
  createProject,
  editProject,
  openTaskFilesDialog,
  closeTaskDialog,
  closeUploadTasksDialog,
  openInviteDialog,
  closeInviteDialog,
  openMoreMenu,
  closeMoreMenu,
  openReadReceipts,
  closeReadReceipts,
  openImportScheduleDialog,
  closeImportScheduleDialog,
  changeSubscriptionDialog,
  closeChangeSubscriptionDialog,
  openCreateSampleProjectDialog,
  closeCreateSampleProjectDialog,
  createSampleProject,
  isLoadingAct,
  notLoadingAct,
  openUserEditDrawer,
  closeUserEditDrawer,
  openStatusChangeDialog,
  closeStatusChangeDialog,
  openCircularProgressLoading,
  closeCircularProgressLoading
};

function closeUserEditDrawer() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.CLOSE_USER_EDIT_DRAWER,
      
    });
  };
}

function openCreateSampleProjectDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.SAMPLE_PROJECT_DIALOG_OPEN
    });
  };
}

function closeCreateSampleProjectDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.SAMPLE_PROJECT_DIALOG_CLOSE
    });
  };
}

function changeSubscriptionDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.SUBDIALOG_OPEN
    });
  };
}

function closeChangeSubscriptionDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.SUBDIALOG_CLOSE
    });
  };
}

function openEditBoard(entityId, formType) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.editBoardInfo) {
      dispatch({
        type: homeConstants.EDITBOARD_OPEN,
        editBoardInfo: {
          entityId: entityId,
          formType: formType
        }
      });
    }
  };
}

function openUserEditDrawer(row) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.OPEN_USER_EDIT_DRAWER,
      editBoardInfo: row
    });
  };
}

function closeTaskDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.TASKDIALOG_CLOSE,
      editBoardInfo: null
    });
  };
}

function openMoreMenu(anchor) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.MOREMENU_OPEN,
      moreMenuAchor: anchor,
       
    });
  };
}

function closeMoreMenu(anchor) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.MOREMENU_CLOSE,
       
    });
  };
}

function openReadReceipts(entityRoute) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.READRECEIPT_OPEN,
      readReceiptRoute: entityRoute
    });
  };
}

function closeReadReceipts() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.READRECEIPT_CLOSE,
       
    });
  };
}

function openTaskDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.TASKDIALOG_OPEN,
       
    });
  };
}

function openTaskFilesDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.UPLOAD_TASKDIALOG_OPEN,
       
    });
  };
}

function openImportScheduleDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.IMPORT_SCHEDULE_OPEN,
       
    });
  };
}

/**
 * Function to close the Import Schedule Dialog and open the invite dialog after
 * @param {opens the Invite dialog after} openInviteDialog
 */
function closeImportScheduleDialog(openInviteDialog) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.IMPORT_SCHEDULE_CLOSED,
      openInviteDialog: openInviteDialog,
       
    });
  };
}

function openInviteDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.INVITEDIALOG_OPEN,
       
    });
  };
}
function openStatusChangeDialog(taskList) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.STATUSCHANGEDIALOG_OPEN,
      changeTaskList: taskList,
       
    });
  };
}

function closeStatusChangeDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.STATUSCHANGEDIALOG_CLOSE,
       
    });
  };
}

function closeUploadTasksDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.UPLOAD_TASKDIALOG_CLOSED,
       
    });
  };
}

function closeInviteDialog() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.INVITEDIALOG_CLOSE,
       
    });
  };
}

export function getNewId(firebase, projectId, formType) {
  return firebase
    .database()
    .ref(`/projects/${projectId}/${formType}`)
    .push().key;
}

function taskDialogSelect(value) {
  return (dispatch, getState) => {
    const state = getState();
    const firebase = getFirebase();

    const newEntityId = getNewId(
      firebase,
      state.homeView.selectedProjectId,
      value
    );
    dispatch({
      type: homeConstants.TASKDIALOG_SELECT,
      editBoardInfo: {
        entityId: newEntityId,
        formType: value
      },
       
    });
  };
}

function createProject() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.ADD_PROJECT_DIALOG,
       
    });
  };
}

function editProject(projectId) {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.EDIT_PROJECT_DIALOG,
      editProjectId: projectId,
       
    });
  };
}

function closeEditBoard() {
  return (dispatch, getState) => {
    dispatch({
      type: homeConstants.EDITBOARD_CLOSE,
      editBoardInfo: null,
       
    });
  };
}

function selectProject(projectId) {
  return (dispatch, getState) => {
    return dispatch({
      type: homeConstants.SELECT_PROJECT,
      selectedProjectId: projectId,
       
    });
  };
}

function isLoadingAct() {
  return (dispatch, getState) => {
    return dispatch({
      type: homeConstants.IS_LOADING,
       
    });
  };
}

function notLoadingAct() {
  return (dispatch, getState) => {
    return dispatch({
      type: homeConstants.NOT_LOADING,
       
    });
  };
}

function createSampleProject() {

  return (dispatch, getState) => {

  };
}

function openCircularProgressLoading() {
  return (dispatch, getState) => {
    return dispatch({
      type: homeConstants.CIRCULAR_PROGRESS_LOADING_OPEN
    });
  };
}

function closeCircularProgressLoading() {
  return (dispatch, getState) => {
    return dispatch({
      type: homeConstants.CIRCULAR_PROGRESS_LOADING_CLOSE
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/home.actions.ts